import { useEffect, useRef } from "react";

export const useDebouncedEffect = (callback: () => void, delay: number, deps: Array<any> = []) => {
  const lastCall = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (lastCall.current) clearTimeout(lastCall.current);

    lastCall.current = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      if (lastCall.current) clearTimeout(lastCall.current);
    };
  }, [...deps, callback, delay]);
};
